import React from 'react'
import './pdcapageheader.scss'

export default ({ title, subtitle = null }) => {
  return (
    <div className='pdca-page-header'>
      <div className='pdca-page-header-main'>
        <h2>{title}</h2>
        {subtitle ? (
          <p>{subtitle}</p>
        ) : null}
      </div>
    </div>
  )
}